<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- formulario -->
    <v-row justify="center">
      <v-col cols="12" sm="10" lg="8">
        <v-card outlined elevation="2" :loading="loadingForm">
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">
              Mi Perfil
            </p>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" sm="10" lg="8">
                <v-form ref="form" v-model="form">
                  <v-select
                    outlined
                    disabled
                    multiple
                    small-chips
                    label="Perfil"
                    :items="perfiles"
                    item-value="id"
                    item-text="perfil"
                    v-model="perfil"
                  >
                  </v-select>

                  <v-select 
                    outlined 
                    disabled
                    dense 
                    label="Regional" 
                    :items="regionales" 
                    item-value="id"
                    item-text="regional" 
                    v-model="regional" 
                  >
                  </v-select>

                  <v-select 
                    outlined
                    disabled 
                    dense 
                    label="Centro de Formación*" 
                    :items="centrosFormacion"
                    item-value="id" 
                    item-text="centro_formacion" 
                    v-model="centroFormacion"
                  >
                  </v-select>

                  <v-text-field 
                    outlined 
                    dense 
                    type="number" 
                    label="Número de Identificación*" 
                    min="1"
                    maxlength="10" 
                    counter 
                    v-model="identificacion" 
                    :rules="identificacionReglas"
                  >
                  </v-text-field>

                  <v-text-field 
                    outlined 
                    dense 
                    type="text" 
                    label="Nombres*" 
                    maxlength="50" 
                    counter 
                    v-model.trim="nombres"
                    :rules="nombresReglas"
                  >
                  </v-text-field>

                  <v-text-field 
                    outlined 
                    dense 
                    type="text" 
                    label="Apellidos*" 
                    maxlength="50" 
                    counter 
                    v-model.trim="apellidos"
                    :rules="apellidosReglas"
                  >
                  </v-text-field>

                  <v-text-field 
                    outlined 
                    dense 
                    type="number" 
                    label="Teléfono*"
                    min="1"
                    maxlength="10" 
                    counter
                    v-model="telefono" 
                    :rules="telefonoReglas"
                  >
                  </v-text-field>

                  <v-text-field 
                    outlined 
                    dense 
                    type="text" 
                    label="Correo Electrónico*" 
                    maxlength="50" 
                    counter
                    v-model.trim="correo" 
                    :rules="correoReglas"
                  >
                  </v-text-field>

                  <v-text-field 
                    outlined 
                    dense
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    append-outer-icon="mdi-pencil" 
                    :type="showPassword ? 'text' : 'password'" 
                    label="Contraseña*"
                    v-model.trim="contrasena" 
                    :rules="contrasenaReglas" 
                    @click:append="showPassword = !showPassword"
                    @click:append-outer="changePassword"
                  >
                  </v-text-field>

                  <template v-if="newPassword">
                    <v-text-field 
                      outlined 
                      dense
                      :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showNewPassword ? 'text' : 'password'" 
                      label="Nueva Contraseña*" 
                      v-model.trim="nuevaContrasena"
                      :rules="nuevaContrasenaReglas" 
                      @click:append="showNewPassword = !showNewPassword"
                    >
                    </v-text-field>

                    <v-text-field 
                      outlined 
                      dense
                      :append-icon="showConfirmNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showConfirmNewPassword ? 'text' : 'password'" 
                      label="Confirmar Nueva Contraseña*"
                      v-model.trim="confirmarNuevaContrasena" 
                      :rules="confirmarNuevaContrasenaReglas"
                      @click:append="showConfirmNewPassword = !showConfirmNewPassword"
                    >
                    </v-text-field>
                  </template>

                  <v-btn 
                    block 
                    large 
                    exact 
                    elevation="2" 
                    color="primary" 
                    class="mt-2 mb-6" 
                    @click="actualizar"
                  >
                    Actualizar
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Alert from '../../../components/admin/Alert.vue'

export default {
  data: () => ({
    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    form: true,
    loadingForm: false,
    
    showPassword: false,
    showNewPassword: false,
    showConfirmNewPassword: false,
    newPassword: false,

    perfil: [],
    regional: null,
    centroFormacion: null,

    identificacion: '',
    identificacionReglas: [
      v => !!v || "Escriba su número de identificación"
    ],

    nombres: '',
    nombresReglas: [
      v => !!v || "Escriba sus nombres"
    ],

    apellidos: '',
    apellidosReglas: [
      v => !!v || "Escriba sus apellidos"
    ],

    telefono: '',
    telefonoReglas: [
      v => !!v || "Escriba su número de telefono",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos"
    ],

    correo: '',
    correoReglas: [
      v => !!v || "Escriba su correo electrónico",
      v => /.+@.+\..+/.test(v) || "Correo electrónico no válido",
    ],

    contrasena: '',
    contrasenaReglas: [
      v => !!v || "Confirme su contraseña"
    ],

    nuevaContrasena: '',
    nuevaContrasenaReglas: [
      v => !!v || "Escriba una nueva contraseña"
    ],

    confirmarNuevaContrasena: ''
  }),

  components: {
    Alert
  },

  mounted() {
    this.$store.dispatch("gestionarPerfiles")
    this.$store.dispatch("crearRegionales")
    this.$store.dispatch("crearCentrosFormacion")
    this.$store.dispatch("editarUsuario", this.$route.params.id_usuario)
    .then((response) => {
      response.usuario_perfil.forEach(perfil => {
        this.perfil.push(perfil.perfil_id);
      });

      this.regional         = response.centro_formacion.regional_id;
      this.centroFormacion  = response.centro_formacion_id;
      this.identificacion   = response.identificacion;
      this.nombres          = response.nombres;
      this.apellidos        = response.apellidos;
      this.telefono         = response.telefono;
      this.correo           = response.correo;
    })
    .catch(() => { });
  },

  computed: {
    perfiles() {
      return this.$store.getters.obtenerPerfiles
    },

    regionales() {
      return this.$store.getters.obtenerRegionales;
    },

    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacion(this.regional);
    },

    confirmarNuevaContrasenaReglas() {
      const reglas = []

      const regla1 = v => !!v || "Confirme la nueva contraseña"
      reglas.push(regla1)

      if (this.nuevaContrasena) {
        const regla2 = v => (!!v && v) === this.nuevaContrasena || 'La nueva contraseña y confirmar nueva contraseña no coinciden'
        reglas.push(regla2)
      }

      return reglas
    }
  },

  methods: {
    changePassword() {
      if (this.newPassword) {
        this.newPassword = false
      }
      else {
        this.newPassword = true
      }
    },

    actualizar() {
      if (this.$refs.form.validate()) {
        const usuario = {
          id: this.$route.params.id_usuario,
          identificacion: this.identificacion,
          nombres: this.nombres,
          apellidos: this.apellidos,
          telefono: this.telefono,
          correo: this.correo,
          password: this.contrasena,
          new_password: this.nuevaContrasena,
          confirm_new_password: this.confirmarNuevaContrasena
        }

        this.loadingForm = true;

        this.$store.dispatch("actualizarPerfilUsuario", usuario)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm = false;
            this.contrasena = null;
            this.newPassword = false

            this.alertType    = "success--text";
            this.alertTitle   = "Actualizado";
            this.alertMessage = response.message;
            this.alert        = true;
          }
          else {
            this.loadingForm  = false;
            this.alertType    = "error--text";
            this.alertTitle   = "Error";        
            this.alertMessage = response.code == 'ERR-001' ? response.message.identificacion[0] : response.message;
            this.alert        = true;
          }
          setTimeout(() => {
            this.alert = false;
          }, 3000);
        })
        .catch(() => { });
      }
    }
  }
};
</script>